<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">

    <thead>
      <tr>
          <th *ngFor="let head of dataTable.headerRow" > <b>{{ head }}</b> </th>
          <th style="text-align: right;"> <b>Mark</b> </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of dataTable.dataRows">
        <td *ngFor="let value of row">{{value}}</td>
        <td style="text-align: right;">
          <label>
            <a class="btn btn-link primary btn-just-icon" 
              (click)="saveEmit('select', row[0], row)">
            <i class="material-icons">{{agregado(row[0]) ? 'check_box' : 'check_box_outline_blank'}}</i></a>
          </label>
          
        </td>
      </tr>
    </tbody>

  </table>
</div>